import { useQueryClient } from '@tanstack/react-query'
import {
  getGetEnginesIdQueryKey,
  getGetEnginesMyQueryKey,
  type PutEnginesIdUnpublishMutationError,
  type PutEnginesIdUnpublishMutationResult,
  usePutEnginesIdUnpublish,
} from '@/types/origin-point-engine'
import { showErrorData, showSuccessData } from '@/lib/toast'
import { useEditorStore } from '@/features/editor/stores/editor-store'

export function useUnpublish() {
  const queryClient = useQueryClient()

  const engineId = useEditorStore((s) => s.draft.engineId)
  const setUnpublishing = useEditorStore((s) => s.setUnpublishing)
  const setPublishStatus = useEditorStore((s) => s.setPublishStatus)

  const mutation = usePutEnginesIdUnpublish({
    mutation: {
      onMutate: () => {
        setUnpublishing(true)
      },
      onSuccess: async (_res: PutEnginesIdUnpublishMutationResult) => {
        setPublishStatus('draft')

        // ✅ 下架后：清掉线上基线
        useEditorStore.getState().markUnpublished()

        if (engineId) {
          await queryClient.invalidateQueries({
            queryKey: getGetEnginesIdQueryKey(engineId),
          })
        }
        await queryClient.invalidateQueries({
          queryKey: getGetEnginesMyQueryKey(),
        })

        showSuccessData('已下架')
      },
      onError: (_err: PutEnginesIdUnpublishMutationError) => {
        showErrorData('下架失败')
      },
      onSettled: () => {
        setUnpublishing(false)
      },
    },
  })

  function unpublish() {
    if (!engineId) {
      showErrorData('下架失败：缺少 engineId')
      return
    }
    mutation.mutate({ id: engineId })
  }

  return {
    unpublish,
    isUnpublishing: mutation.isPending,
  }
}
